module.exports = __webpack_public_path__ + "static/media/dev_sharma_ji.905149f9.jpg";